/* อัปโหลดรูป 1 รูป แล้วคืน path (เก็บใน field ของฟอร์ม) — ใช้กับ Form.Item ได้ตรง ๆ */
import { useState } from "react";
import { Button, Flex, Image, Upload, message } from "antd";
import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { uploadImage, apiError } from "../../service/Ak.service";
import { fileUrl } from "../../utils/util";

export default function ImageUpload({ value, onChange, type, disabled }) {
  const [busy, setBusy] = useState(false);

  const before = async (file) => {
    if (file.size > 5 * 1024 * 1024) {
      message.error("รูปใหญ่เกิน 5 MB");
      return false;
    }
    setBusy(true);
    try {
      const res = await uploadImage(file, type);
      onChange?.(res.data?.data?.path || null);
    } catch (e) {
      message.error(apiError(e, "อัปโหลดรูปไม่สำเร็จ"));
    } finally {
      setBusy(false);
    }
    return false;
  };

  return (
    <Flex gap={12} align="center">
      {value ? (
        <Image src={fileUrl(value)} width={96} height={96} style={{ objectFit: "cover", borderRadius: 8 }} />
      ) : (
        <div className="ak-img-empty">ไม่มีรูป</div>
      )}
      <Flex vertical gap={6}>
        <Upload accept="image/png,image/jpeg,image/webp" showUploadList={false} beforeUpload={before} disabled={disabled}>
          <Button icon={<UploadOutlined />} loading={busy} disabled={disabled}>
            {value ? "เปลี่ยนรูป" : "อัปโหลดรูป"}
          </Button>
        </Upload>
        {value && !disabled && (
          <Button size="small" danger type="text" icon={<DeleteOutlined />} onClick={() => onChange?.(null)}>
            เอารูปออก
          </Button>
        )}
      </Flex>
    </Flex>
  );
}
